import React, { useContext, useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../COMPONENTS/header/Header";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../../../CONTEXT/AuthProvider";

const ViewSubscriberDetails = () => {
  const { auth } = useContext(AuthContext);
  const accessToken = auth.accessToken;

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const location = useLocation();
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    subscriberCode: location.state.subscriberDetails.subscriberCode,
    subscriberName: location.state.subscriberDetails.subscriberName,
  });

  const handleFormSubmit = async (values) => {
    const subscriberCode = values.subscriberCode;
    const subscriberName = values.subscriberName;

    try {
      const data = {
        subscriberCode,
        subscriberName,
        id: location.state.subscriberDetails.id
      };

      await axios.post("/api/update-subscriber", data, {
        headers: {
          'Authorization': 'Bearer ' + accessToken
        }
      });

      // Update the state if needed
      setFormValues({
        ...formValues,
        subscriberCode,
        subscriberName,
      });

      navigate("/listofSubscribers");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="20px">
          <Header
            title="VIEW SUBSCRIBER"
            subtitle="View and update a subscriber in the system"
          />

          <Formik
            onSubmit={handleFormSubmit}
            initialValues={formValues}
            validationSchema={checkoutSchema}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Subscriber Code"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.subscriberCode}
                    name="subscriberCode"
                    error={!!touched.subscriberCode && !!errors.subscriberCode}
                    helperText={touched.subscriberCode && errors.subscriberCode}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Subscriber Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.subscriberName}
                    name="subscriberName"
                    error={!!touched.subscriberName && !!errors.subscriberName}
                    helperText={touched.subscriberName && errors.subscriberName}
                    sx={{ gridColumn: "span 2" }}
                  />
                </Box>
                <Box display="flex" justifyContent="end" mt="20px">
                  <Button type="submit" color="success" variant="contained">
                    Update Subscriber
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Box>
      </main>
    </div>
  );
};

const checkoutSchema = yup.object().shape({
  subscriberCode: yup.string().required("required"),
  subscriberName: yup.string().required("required"),
});

export default ViewSubscriberDetails;
